class RedirectPopup {
    constructor() {
        if (!theme.redirect_popup?.enabled) return;
        if (this.getCookie('store_redirect_choice')) return;

        this.init();
    }

    init() {
        fetch(theme.routes.shop_url + '/browsing_context_suggestions.json')
            .then(res => res.json())
            .then((response) => this.handleResponse(response))
            .catch(console.error);
    }

    handleResponse(response) {
        const country = response.detected_values?.country?.handle;
        if (!country) return;

        const rule = this.getRedirectRule(country);
        if (!rule) return;

        this.show({
            country: response.detected_values.country.name,
            store: rule.store_name || 'recommended store',
            redirectUrl: rule.redirect_link,
            storeCountry: rule.store_country,
            storeCountryFlag: rule.store_country_flag
        });
    }

    getRedirectRule(country) {
        const countryCode = country.toUpperCase();

        for (const rule of theme.redirect_popup.rules) {
            if (!rule.redirect_link || !rule.countries) continue;

            const countries = rule.countries
                .split(',')
                .map(item => item.trim().toUpperCase());

            if (countries.includes(countryCode)) {
                return rule;
            }
        }

        return null;
    }

    show({ country, store, redirectUrl, storeCountry, storeCountryFlag }) {
        const template = document.getElementById('RedirectPopupTemplate');

        if (!template || document.querySelector('.redirect-popup')) return;

        const popup = template.content.firstElementChild.cloneNode(true);

        this.replacePlaceholders(popup, country, store, storeCountry);

        const goButton = popup.querySelector('[data-redirect-link]');
        if (goButton) {
            if (storeCountryFlag) {
                const flag = document.createElement('img');
                flag.src = storeCountryFlag;
                flag.alt = storeCountry || '';
                flag.width = 25;
                flag.height = 25;
                goButton.prepend(flag);
            }

            goButton.href = this.buildRedirectUrl(redirectUrl);

            goButton.addEventListener('click', () => {
                this.setCookie('store_redirect_choice', 'accepted');
            });
        }
	    
	    popup.querySelector('.redirect-popup__close')?.addEventListener('click', () => {
		    this.setCookie('store_redirect_choice', 'dismissed');
		    popup.remove();
	    });

        popup.querySelector('.redirect-popup__stay')?.addEventListener('click', () => {
            this.setCookie('store_redirect_choice', 'dismissed');
            popup.remove();
        });

        popup.querySelector('.redirect-popup__overlay')?.addEventListener('click', () => {
            this.setCookie('store_redirect_choice', 'dismissed');
            popup.remove();
        });

        document.body.appendChild(popup);
    }

    replacePlaceholders(popup, country, store, storeCountry) {
        popup.querySelectorAll('[data-template]').forEach((element) => {
            element.innerHTML = element.dataset.template
                .replaceAll('[country]', `<strong>${country}</strong>`)
                .replaceAll('[store]', `<strong>${store}</strong>`)
                .replaceAll('[redirect_target_country]', storeCountry);
        });
    }

    getCookie(name) {
        const match = document.cookie.match(
            new RegExp('(?:^|; )' + name + '=([^;]*)')
        );

        return match ? decodeURIComponent(match[1]) : null;
    }

    setCookie(name, value, days = 365) {
        document.cookie =
            `${name}=${encodeURIComponent(value)}; Max-Age=${days * 24 * 60 * 60}; Path=/; SameSite=Lax`;
    }

    buildRedirectUrl(baseUrl) {
        const url = new URL(baseUrl);

        if (theme.redirect_popup.preserve_path) {
            url.pathname = window.location.pathname;
            url.search = window.location.search;
            url.hash = window.location.hash;
        }

        url.searchParams.set('store-switch', '1');
        return url.toString();
    }
}

theme.redirectPopup = new RedirectPopup();